import { h, createRef } from "preact";
import { useEffect, useState } from "preact/hooks";
import { format } from "date-fns";

import Dropdown from "./Dropdown.jsx";
import DropdownInput from "./DropdownInput.jsx";
import i18n from "../i18n";
import { classNames } from "../helpers.js";

function pad(value) {
  return (value < 10 ? "0" : "") + value;
}

export default function YearMonthPicker({
  error,
  label,
  min,
  max,
  onInput,
  value,
}) {
  const monthRef = createRef();
  const yearRef = createRef();
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentYear, setCurrentYear] = useState("");

  const MONTHS = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];
  const years = Array.from({ length: 100 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return {
      text: year,
      value: year,
    };
  });

  useEffect(() => {
    let date = Date.parse(value);
    console.log(value, date);
    if (date) {
      date = new Date(date);
      setCurrentMonth(date.getMonth() + 1);
      setCurrentYear(date.getFullYear());
    } else {
      setCurrentMonth("");
      setCurrentYear("");
    }
  }, [value]);

  useEffect(() => {
    if (currentMonth && currentYear) {
      const date = new Date(currentYear, currentMonth - 1, 1);

      // setTimeout(() => {
      onInput(format(date, "yyyy-MM-dd"));
      // }, 50);
    }
  }, [currentMonth, currentYear]);

  function onMonthClick(month) {
    console.log("month", month);
    setCurrentMonth(month);
  }
  function onYearClick(year) {
    setCurrentYear(year);
  }

  function showMonth(index) {
    if (!index) {
      return "";
    }

    return MONTHS.find(({ value }) => value === index).text;
  }

  return (
    <div
      class={classNames(
        "year-month-picker",
        error && "year-month-picker--invalid"
      )}
    >
      <label class="t-overline" for="month">
        {label}
      </label>
      <div class="year-month-picker__row">
        <Dropdown
          class="year-month-picker__dropdown-element"
          triggerClass="year-month-picker__dropdown-input"
          items={MONTHS}
          ref={monthRef}
          onClick={(event) => {
            monthRef.current.close();
            onMonthClick(event);
          }}
          container={document.body}
        >
          <DropdownInput
            label={i18n.t("component.year_month_picker.month")}
            error={error}
          >
            {showMonth(currentMonth)}
          </DropdownInput>
        </Dropdown>
        <Dropdown
          class="year-month-picker__dropdown-element"
          triggerClass="year-month-picker__dropdown-input"
          items={years}
          ref={yearRef}
          onClick={(event) => {
            yearRef.current.close();
            onYearClick(event);
          }}
          container={document.body}
        >
          <DropdownInput
            label={i18n.t("component.year_month_picker.year")}
            error={error}
          >
            {currentYear}
          </DropdownInput>
        </Dropdown>
      </div>
      {error && <span class="year-month-picker__helper-text">{error}</span>}
    </div>
  );
}
